import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import MessageItem from './MessageItem';
import map from 'lodash/map';
import size from 'lodash/size';

import { loadNotifications, deleteNotificationMessage } from '../../actions'
import { isSubscribedSelector } from '../../reducers/selectors'

// import { CSSTransition, TransitionGroup } from 'react-transition-group';


const mapStateToProps = state => ({ messages: state.notifications, currentProject: state.currentProject, isSubscribed: isSubscribedSelector(state)});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({loadNotifications, deleteNotificationMessage}, dispatch)
};


class Notifications extends Component {
  
  componentWillMount (){
    this.props.loadNotifications()
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.currentProject !== this.props.currentProject){
      this.props.loadNotifications()
    }
  }
  
  render() {
    const { messages, deleteNotificationMessage, isSubscribed} = this.props;
    
    return size(messages) > 0 ?
      (<div className="notifications container">
        {map(messages, (message,idx) => {
          const showMsg = !message.activate_btn || (message.activate_btn && !isSubscribed)
          return showMsg && <MessageItem {...message} key={idx} toggle={()=>deleteNotificationMessage(idx)} />
        })}
      </div>) : null;
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(Notifications);


// WEBPACK FOOTER //
// ./src/components/notifications/Notifications.js